import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Card, Container, Row, Col } from "react-bootstrap"
import { partnerApi } from '../../../api'
import _ from 'lodash'

class ExplorePartners extends Component {
    static propTypes = {
        currentPartnerID: PropTypes.number,
        token: PropTypes.string
    };
    static defaultProps = {
        currentPartnerID: 0,
        token: ""
    };


    constructor(props) {
        super();
        this.state = {
            partners: []
        }
    }

    componentDidMount = async () => {

        const obj = {
            "posts_per_page": 4,
            "env": process.env.REACT_APP_MODE,
            //"posts_status":'publish'
        }
        if (this.props.currentPartnerID > 0) {
            obj['ids_except'] = [this.props.currentPartnerID];
        }

        const apiResponse = await partnerApi.searchPartners(this.props.token, 1, obj);
        const respJson = await apiResponse.json();
        if (apiResponse.status === 200) {
            console.log(respJson)
            this.setState({ partners: respJson.data });
        } else {
            console.log(`error in partners load`, respJson);
        }
    }



    render() {
        const partners = this.state.partners

        return (
            <Container className="my-5 ">
                <Row>
                    <Col>
                        <h3>{`Explore more partners`}</h3>
                    </Col>
                </Row>
                <Row className="post-card-slider">
                    {partners.map(card => <Col sm="3" md="3">
                        <React.Fragment>
                            <div  className="post-card-box">
                                <a href={`/partners/${card.post_name}`}>
                                    <img width="100%" src={card.logo ? card.logo.sizes.logo : ''} />
                                </a>
                            </div>
                            <div className="post-card-box-footer">
                                <p>{card.post_title}</p>
                            </div>
                        </React.Fragment>



                    </Col>)}
                </Row>
            </Container>
        )
    }
}

export default ExplorePartners;